/** دسترسی به بخش مانیتورینگ: نقش admin/superadmin یا پرچم داده‌شده توسط ادمین اصلی. */
export function canAccessMonitoring(): boolean {
  const r = (localStorage.getItem('admin_role') || '').trim().toLowerCase();
  if (r === 'admin' || r === 'superadmin') return true;
  return localStorage.getItem('admin_monitoring_access') === '1';
}

export function setMonitoringAccessFromLogin(value: boolean | undefined | null): void {
  localStorage.setItem('admin_monitoring_access', value ? '1' : '0');
}

export function clearMonitoringAccess(): void {
  localStorage.removeItem('admin_monitoring_access');
}
